import { Routes } from '@angular/router';

import { BlankComponent, FullComponent } from '@app/shared';

export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./state-guide/state-guide.module').then(m => m.StateGuideModule)
      },
      {
        path: 'state-guide',
        loadChildren: () =>
          import('./state-guide/state-guide.module').then(
            m => m.StateGuideModule
          )
      },
      {
        path: 'content',
        loadChildren: () =>
          import('./content/content.module').then(m => m.ContentModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./authentication/authentication.module').then(
            m => m.AuthenticationModule
          )
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];
